import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { FaWhatsapp } from 'react-icons/fa';
import Home from "./pages/Home";
import About from "./pages/About";
import Team from "./pages/Team";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import Onboarding from "./pages/Onboarding";
import Header from "./components/Header";
import Footer from "./components/Footer";
import VerifyEmail from "./pages/VerifyEmail";
import ResendVerification from "./pages/ResendVerification";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Support from "./pages/Support";
import Pricing from "./pages/Pricing";
import Features from "./pages/Features";
import Tutorials from "./pages/Tutorials";
import Tutorial from "./pages/Tutorial";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import AdminPortal from "./pages/AdminPortal";
import PrivateRoute from "./PrivateRoute";
import LoginModal from "./components/LoginModal";
import GoogleOneTap from "./components/GoogleOneTap";
import { useAuth } from "./AuthContext";

const AppContent = () => {
  const location = useLocation();
  const { user } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);
  
  // Disable auto-popup login modal
  // Show login modal every 24 seconds if user is not logged in
  // useEffect(() => {
  //   if (!user) {
  //     const timer = setInterval(() => {
  //       setShowLoginModal(true);
  //     }, 24000); // Every 24 seconds

  //     return () => clearInterval(timer);
  //   }
  // }, [user]);

  const showHeader = true;
  const showFooter = location.pathname !== "/onboarding";

  return (
    <div className="flex flex-col min-h-screen">
      {showHeader && <Header />}
      <main className={showHeader ? "flex-grow pt-16 lg:pt-[68px]" : "flex-grow"}>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/resend-verification" element={<ResendVerification />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/support" element={<Support />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/features" element={<Features />} />
          <Route path="/tutorials" element={<Tutorials />} />
          <Route path="/tutorial/:type/:id" element={<Tutorial />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

           {/* Public routes - No login required */}
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<Team />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/onboarding" element={<Onboarding />} />
          
          {/* Private routes */}
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute><AdminPortal /></PrivateRoute>} />
        </Routes>
      </main>
      {showFooter && <Footer />}
      
      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/919257734350"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 group"
        aria-label="Chat with us on WhatsApp"
      >
        <div className="flex items-center gap-2 sm:gap-3 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105">
          {/* Text - Hidden on small mobile, visible on larger screens */}
          {/* <span className="hidden sm:flex text-sm lg:text-base font-semibold pl-4 pr-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
            Chat with us on WhatsApp
          </span> */}
          {/* Icon */}
          <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center">
            <FaWhatsapp className="text-3xl sm:text-4xl" />
          </div>
        </div>
      </a>
      
      {/* Login Modal */}
      <LoginModal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)} />
      
      {/* Google One Tap Auto Popup */}
      <GoogleOneTap />
    </div>
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
};

export default App;
